//import { NgUploaderOptions } from '@angular-ex/uploader';
//import { UploadedFile } from '@angular-ex/uploader/src/classes';
import { JobseekerService } from '../shared/services/jobseeker.service';
import { LanguageProficiencyLevelModel } from '../../shared/models/language-proficiency-level-model';
import { Utils } from '../../shared/utils';
import { JobseekerLanguageModel } from '../shared/models/jobseeker-language-model';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { WorldLanguageModel } from '@admin/shared/models/world-language-model';

@Component({
  selector: 'hr-jobseeker-language-item',
  templateUrl: './jobseeker-language-item.component.html',
  styleUrls: ['./jobseeker-language-item.component.less'],
  standalone: false,
})
export class JobseekerLanguageItemComponent implements OnInit {
  @Output()
  public onCancelEdit: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  public onUpdate: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input('language')
  public languageInput: JobseekerLanguageModel;

  @Input()
  public languageproficiencyLevelList: LanguageProficiencyLevelModel[];
  @Input()
  public worldLanguages: WorldLanguageModel[];

  public language: JobseekerLanguageModel;
  @Input()
  public isInEditMode: boolean = false;
  public isInAddMode: boolean = false;

  public selectedFileName: string;

  //public uploadOptions: NgUploaderOptions;

  constructor(
    private jobseekerService: JobseekerService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['languageInput'] &&
      changes['languageInput'].currentValue != null
    ) {
      this.language = Utils.cloneObject(
        this.languageInput,
        JobseekerLanguageModel
      );
      this.isInAddMode = this.language.jobseekerLanguageId < 0;
      //this.initializeFieldsState();
    }
  }

  public onEditLanguageClick() {
    this.isInEditMode = true;
  }

  public getDownloadUrl() {
    let language = this.language;
    if (language == null) return null;
    if (language.jobseekerLanguageId)
      return this.jobseekerService.getLanguageAttachmentDownloadUrl(
        language.jobseekerId,
        language.jobseekerLanguageId
      );
  }

  public onDownloadLanguageAttachment(formId: string) {
    let form = <any>document.getElementById(formId);
    form.submit();
  }

  public onCancelClick() {
    this.onCancelEdit.emit(true);
  }

  /*public handleUpload(data: UploadedFile){
    setTimeout(() => {
      this.zone.run(() => {
        //this.response = data;
        console.dir(data);
        if (data && data.response) {
          this.selectedFileName = JSON.parse(data.response).fileName;
        }
       });
    });
}*/

  public onSaveClick() {
    this.jobseekerService
      .saveJobseekerLanguage(this.language, this.selectedFileName)
      .subscribe((d) => {
        this.onUpdate.emit(true);
      });
  }

  ngOnInit() {
    /*this.uploadOptions = new NgUploaderOptions({
            url: this.urlConfig.api.file.upload,
            autoUpload: true,
            calculateSpeed: true
    });*/
  }
}
